export default __webpack_public_path__ + "static/facebook-4bc4c6f140fc7359bf93cbef6485c8ef.png";